require('../modules/web.dom.iterable');

require('../modules/es6.string.iterator');

module.exports = require('../modules/core.is-iterable');